<template>
    <div>
     <div class="page-header">
      <div class="pageTitle">
        <div class="pageName">{{ page.title }}</div>
      </div>
    </div>
    <div class="row">
      <p style="margin: 20px 15px 10px">
        {{ page.desc }}
      </p>
    </div>
        <div class="row">
            <div style="margin: 5px 15px 10px">
                <tabs v-model="defactiveIndex">
                    <pane label="IGMP Global">
                        <igmp-snoop-global/>
                    </pane>
                    <pane label="IGMP Port">
                        <igmp-config />
                    </pane>
                    <pane label="IGMP Mcast Table">
                        <igmp-mcast-table/>
                    </pane>
                    <pane label="IGMP Router">
                        <igmp-router-static/>
                    </pane>
                    <pane label="IGMP Router Table">
                        <igmp-router/>
                    </pane>

                </tabs>
            </div>
        </div>
    </div>
</template>

<script>
import Pane from "./../components/Pane.vue"
import Tabs from "./../components/Tabs.vue"
import IgmpConfig from "./../views/IgmpConfig.vue"
import IgmpMcastTable from "./../views/IgmpSnoopList.vue"
import IgmpSnoopGlobal from "./../views/IgmpSnoopGlobal.vue"
import IgmpRouterStatic from "./../views/IgmpRouterStatic.vue"
import IgmpRouter from "./../views/IgmpRouter.vue"
import en from "./../lang/en-US.js"
import { get, post } from "@/utils/http.js"

export default {
    name: "igmp",
    components: {
        Pane,
        Tabs,
        IgmpConfig,
        IgmpMcastTable,
        IgmpSnoopGlobal,
        IgmpRouter,
        IgmpRouterStatic,
    },

    data() {
        return {
            page: en.page.igmpconfig,
            defactiveIndex: 0,
        }
    },

    methods: {
  },

}
</script>